import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'

export default function Blog() {
  const [posts, setPosts] = useState([])
  useEffect(() => {
    fetch('/admin/api/public/posts').then(r => r.ok ? r.json() : []).then(setPosts).catch(() => setPosts([]))
  }, [])
  return <div id="main-content" className="max-w-4xl mx-auto px-4 py-12">
    <Helmet><title>FastAudio Blog</title><meta name="description" content="Guides and updates from FastAudio." /></Helmet>
    <h1 className="text-3xl font-bold mb-8">FastAudio Blog</h1>
    {!posts.length ? <p className="text-muted-foreground">No articles have been published yet.</p> : (
      <div className="grid gap-4">{posts.map(post => <article key={post.slug} className="p-5 bg-card border border-border rounded-xl">
        <h2 className="text-xl font-bold"><Link className="hover:text-primary" to={`/blog/${post.slug}`}>{post.title}</Link></h2>
        {post.excerpt && <p className="mt-2 text-muted-foreground">{post.excerpt}</p>}
        <Link className="inline-block mt-3 text-sm font-semibold text-primary" to={`/blog/${post.slug}`}>Read article</Link>
      </article>)}</div>
    )}
  </div>
}